import { NamespacedStoreState } from '@Types/store.types';
import { createSelector } from '@reduxjs/toolkit';
import { moduleNamespace } from '@Store/config.store';
import {
	ResultsSummaryState,
	RiskResultsSummary,
} from '@Types/riskResultsSummary.types';

const parseNamespace = (state: NamespacedStoreState) => state[moduleNamespace];

const resultsSummarySelector = createSelector(
	parseNamespace,
	state => state.RiskStore.resultsSummary,
);

export interface ResultsSummaryView {
	status: ResultsSummaryState['status'];
	data: RiskResultsSummary | undefined;
}

// Only ever returns data for the config asked about, so a component can't
// render another model's numbers even if the slice hasn't caught up yet.
export const selectResultsSummaryForConfig = createSelector(
	[
		resultsSummarySelector,
		(_state: NamespacedStoreState, configId: string) => configId,
	],
	(slice, configId): ResultsSummaryView =>
		slice.configId === configId
			? { status: slice.status, data: slice.data }
			: { status: 'idle', data: undefined },
);

export const selectCompletedRun = createSelector(
	resultsSummarySelector,
	slice => ({
		configId: slice.completedRunConfigId,
		count: slice.completedRunCount,
	}),
);
